import type { GuaArticle } from '@/mocks/gua88-news';

const trustCls: Record<GuaArticle['trust'], string> = {
  实锤: 'bg-primary-100 text-primary-800',
  '官方/本人回应': 'bg-accent-100 text-accent-900',
  网友分析: 'bg-secondary-100 text-secondary-900',
  待验证: 'bg-foreground-100 text-foreground-700',
};

export function TrustBadge({ trust }: { trust: GuaArticle['trust'] }) {
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ${trustCls[trust]}`}
    >
      <i className="ri-record-circle-line text-xs"></i>
      {trust}
    </span>
  );
}

export function TagBadge({ tag }: { tag: string }) {
  return (
    <span className="inline-flex whitespace-nowrap rounded-full bg-background-200 px-2 py-0.5 text-[11px] font-medium text-foreground-700">
      {tag}
    </span>
  );
}

export function SectionHead({
  kicker,
  title,
  desc,
}: {
  kicker: string;
  title: string;
  desc?: string;
}) {
  return (
    <div className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="font-display text-sm uppercase tracking-[0.2em] text-primary-500">{kicker}</p>
        <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-700">{desc}</p>}
      </div>
    </div>
  );
}